// src/i18n/es/labels.ts
// Etiquetas reutilizables (catálogo + asignación a dispositivos)

const labels = {
  deviceCard: {
    title: 'Etiquetas',
    subtitle: 'Clasifique el equipo con etiquetas reutilizables, independientes del nombre.',
    empty: 'Sin etiquetas.',
    selectScope: 'Categoría',
    freeLabel: 'Sin categoría',
    valuePlaceholder: 'Escriba o elija un valor…',
    hint: 'Elija una categoría y un valor. Puede crear un valor nuevo si tiene permiso.',
  },
  catalog: {
    pageTitle: 'Catálogo de etiquetas',
    pageDescription: 'Cree categorías y valores para etiquetar los equipos, independientemente del nombre del equipo.',
    scopes: 'Categorías',
    newScope: 'Nueva categoría',
    editScope: 'Editar categoría',
    freeLabels: 'Etiquetas sin categoría',
    freeLabelsHint: 'Etiquetas libres, sin clave.',
    valuesHint: 'Valores de esta categoría (p. ej. XS-100).',
    noValues: 'Aún no hay valores.',
    newValuePlaceholder: 'Nuevo valor…',
    exclusiveShort: 'única',
    confirmDeleteScope: '¿Eliminar la categoría «%{key}» y todos sus valores y asignaciones?',
  },
  fields: {
    key: 'Clave',
    displayName: 'Nombre visible',
    color: 'Color',
    exclusive: 'Valor único por equipo',
  },
  hints: {
    key: 'La clave no podrá cambiarse después (p. ej. model, locks).',
  },
  owner: {
    global: 'Global (todos los grupos)',
    group: 'De un grupo',
  },
  errors: {
    loadFailed: 'No se han podido cargar las etiquetas.',
    assignFailed: 'No se ha podido asignar la etiqueta.',
    createFailed: 'No se ha podido crear la etiqueta.',
    removeFailed: 'No se ha podido quitar la etiqueta.',
    deleteFailed: 'No se ha podido eliminar.',
  },
};

export default labels;
